import { jsx as _jsx } from "react/jsx-runtime";
/********************************************************************************
 * Copyright (c) 2026 Contributors to the Eclipse Foundation
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * https://www.eclipse.org/legal/epl-2.0
 *
 * SPDX-License-Identifier: EPL-2.0
 ********************************************************************************/
import { forwardRef } from 'react';
import { Container } from '@mui/material';
/**
 * A MUI `Container` plus the standard page margins (a top offset below the nav and
 * a gap above the footer). For page-level content; non-pages or custom spacing
 * should use `Container` directly.
 */
export const PageContainer = forwardRef(function PageContainer({ fluid, flushTop, flushBottom, sx, ...props }, ref) {
    return (_jsx(Container, { ref: ref, maxWidth: fluid ? false : 'xl', disableGutters: fluid, sx: [
            {
                pt: flushTop ? 0 : { xs: '1.75rem', sm: '2.5rem' },
                pb: flushBottom ? 0 : { xs: '2.5rem', sm: '4rem' }
            },
            ...(Array.isArray(sx) ? sx : [sx])
        ], ...props }));
});
//# sourceMappingURL=page-container.js.map